import { render, staticRenderFns } from "./ShipmentSuspendNotification.vue?vue&type=template&id=6ab9b95c&"
import script from "./ShipmentSuspendNotification.vue?vue&type=script&lang=ts&"
export * from "./ShipmentSuspendNotification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports